<template>
  <ion-page>
    <master-layout pageTitle="افزودن کاربر سیستمی">
      <AjaxForm route="Admin/Add">
        <ion-card>
          <ion-card-content>
            <div class="mb-2">
              <label>نام کامل</label>
              <input type="text"  name="fullname" class="form-control" >
            </div>

            <div class="mb-2">
              <label>نام کاربری</label>
              <input type="text"  name="username" class="form-control" >
            </div>

            <div class="mb-2">
              <label>تلفن همراه</label>
              <input type="tel" name="phone" class="form-control" >
            </div>

            <div class="mb-2">
              <label>کد ملی</label>
              <input type="text" name="national_code" class="form-control" >
            </div>

            <div class="mb-2">
              <label>ایمیل</label>
              <input name="email" type="email" class="form-control" >
            </div>
<!--            <div class="mb-2">-->
<!--              <label>نقش کاربری</label>-->
<!--              <select class="form-control" name="role_id">-->
<!--                <option v-for="(item,index) in roles" :key="index" :value="item._id">{{item.title}}</option>-->
<!--              </select>-->
<!--            </div>-->

            <div class="mb-2">
              <label>کلمه عبور</label>
              <input type="password" name="password" class="form-control">
            </div>

            <button class="btn btn-block btn-lg btn-success mt-2" type="submit">
              افزودن مدیر <i class="fas fa-plus"></i>
            </button>
          </ion-card-content>
        </ion-card>
      </AjaxForm>
    </master-layout>
  </ion-page>
</template>

<script>
import {mapActions} from "vuex";
import {IonPage,IonCard,IonCardContent} from '@ionic/vue';
import AjaxForm from "@/components/AjaxForm";

// import {getFormData} from '@/shared/helper'

export default {
  name: "AddWarehouse",
  components: {
    AjaxForm,
    IonPage,IonCard,IonCardContent
  },
  data()
  {
    return {
      roles: [],
    }
  },
  async mounted()
  {

  },
  methods: {
    ...mapActions("admin", {
      // getRoles: 'getRoles',
    }),
  }
}

</script>

<style scoped>

</style>